/**
 * @author      sam@zumper.com (Sam Sherman)
 * @copyright   Copyright (c) 2019, Zumper
 * @description blog reducers
 */

import { payloadReducer } from '@zcode/reducers'
import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'
import { CLEAR_BLOG_POSTS, RECEIVE_BLOG_POSTS } from '../constants/index'
import { default as metaReducer } from './metaReducer'

const blogReducer = combineReducers({
  blogPosts: handleActions(
    {
      [RECEIVE_BLOG_POSTS]: payloadReducer,
      [CLEAR_BLOG_POSTS]: () => null,
    },
    null
  ),
  meta: metaReducer,
})

export default blogReducer
